<template>
	<view class="main">
		<slot></slot>
	</view>
</template>

<script>
	export default {
		name:"Main"
	}
</script>
<script setup>
</script>

<style scoped>
</style>